import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, BoxProps, withTypography } from 'components/ui';
import { primitive, spacing } from 'styles/constants';

const styles = StyleSheet.create({
  container: {
    backgroundColor: primitive.$fieryRed,
    marginVertical: spacing.$4,
    padding: spacing.$4,
  },
  header: {
    borderBottomColor: primitive.$white,
    borderBottomWidth: 1,
  },
  lineItem: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  title: {
    marginLeft: spacing.$1,
    marginVertical: spacing.$2,
    textTransform: 'uppercase',
  },
  titleContainer: {
    alignItems: 'center',
    flexDirection: 'row',
  },
});

export const Container = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.container, style],
  });

export const TextBase = withTypography({
  color: primitive.$white,
});

export const Header = withTypography({
  color: primitive.$white,
  style: styles.header,
});

export const Title = withTypography({
  color: primitive.$white,
  style: styles.title,
});

export const TitleContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.titleContainer, style],
  });

export const LineItem = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, {
    ...props,
    style: [styles.lineItem, style],
  });

export const TextDetails = withTypography({
  color: primitive.$white,
  variant: 'copyOne',
});
